
<div class=" refund_wrapper refund_another">
<span mat-button (click)="onNoClick()" class="close-btn-modal material-icons">
  close
</span>
  <!-- <div class="new-container"> -->
    <div class="dialoghead assignAdvo_wrapper">
      <h1>Refund Request Form</h1>
    </div>
    <mat-dialog-content>
    <div class="subwrapper ">
      <div class="formStyle user-form">
        <mat-card-content
          class="addEditPageWrapper practice_form_style form_title_style"
        >
          <div class="AddEditBlog taxonomies_formstyle">
            <div class="addEditForm">
              <ng-container *ngIf="this.userformdata">
                <lib-showform
                  [formdata]="userformdata"
                  [formfieldrefresh]="formfieldrefresh"
                  [formfieldrefreshdata]="formfieldrefreshdata"
                  (onFormFieldChange)="listenFormFieldChange($event)"
                 
                >
                </lib-showform>
              </ng-container>
                  <mat-progress-bar *ngIf="loader" mode="indeterminate"></mat-progress-bar>

              
            </div>
          </div>
        </mat-card-content>
      </div>
    </div>
  </mat-dialog-content>
  <!-- </div> -->
    <div class="confirm-modal" *ngIf="showConfirmModal">
    <div class="confirm-overlay">
      <div class="confirm-overlay-ex">
        <div class="confirm-box">
          <div class="confirm-header">
            <h3>Confirm Payment</h3>
            <button class="confirm-custom-close" (click)="closeConfirmModal()">
              ×
            </button>
          </div>

          <div class="confirm-body">
            <p>Are you sure you want to proceed with the payment?</p>
          </div>

          <div class="confirm-footer">
            <button class="confirm-cancel" (click)="closeConfirmModal()">
              Cancel
            </button>
            <button class="confirm-yes" (click)="submitConfirmedData()">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
